export default () => ({
  notifications: [],
  hasUnreadNotifications: false,
  openedNotifications: [],
})
